import { toggleChatListPending } from './actions';
import {
  ESection,
  fetchChatsBulkOperationsReadAllFromSectionDesktop,
  TChatsBulkOperationsReadAllFromSectionDesktopResponse,
} from '../../repositories/chats/v1/chats-bulk-operations-read-all-from-section-desktop';
import { TThunkAction } from '../../types/redux/thunk';
import { showAlert } from '../alert';

/**
 * Пометить все чаты как прочитанные
 * @param {ESection} section раздел в котором нужно прочитать сообщения
 */
export const markAllChatsAsRead =
  (section: ESection): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsBulkOperationsReadAllFromSectionDesktopResponse =
        await fetchChatsBulkOperationsReadAllFromSectionDesktop({
          httpApi,
          parameters: {
            section,
          },
          config: { requestConfig: { withCredentials: true } },
        });

      if (statusCode !== 200) {
        logger.warning('Код ответа не 200', {
          message: 'Не удалось пометить все чаты прочитанными',
          domain: 'src/shared/actions/chatList/markAllChatsAsRead.ts',
          statusCode,
          messsage: response.message,
          errors: JSON.stringify(response.errors),
        });

        dispatch(showAlert({ message: 'Не удалось пометить все чаты прочитанными' }));
      }
    } catch (ex) {
      logger.error(ex, {
        message: 'Не удалось пометить все чаты прочитанными',
        domain: 'src/shared/actions/chatList/markAllChatsAsRead.ts',
      });

      dispatch(showAlert({ message: 'Не удалось пометить все чаты прочитанными' }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
